import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { generatePilotKey, fetchTeamRequests } from "../Apis/AdminApis";
import { useNavigate } from "react-router-dom";
import PopupMessage from "../PopupMessage/PopupMessage";
import { FiChevronLeft,FiChevronRight } from "react-icons/fi";
import pavamanLogo from "../images/drone.png";
import "./PilotKeyGeneration.css";

const PilotKeyGeneration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    admin_id: ""
  });
  const [isLoading, setIsLoading] = useState(true);
const [isGeneratingKey, setIsGeneratingKey] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [role, setRole] = useState("");
  const [pilots, setPilots] = useState([]);
  const [eligibleAdmins, setEligibleAdmins] = useState([]);
  const [showKeyModal, setShowKeyModal] = useState(false);
  const [isSwitchedAdmin, setIsSwitchedAdmin] = useState(false);
const [isOwnSwitchedCompany, setIsOwnSwitchedCompany] = useState(false);
const [switchedAdminId, setSwitchedAdminId] = useState("");
  const [stats, setStats] = useState({
    generated_keys: 0,
    key_limit: 0,
    remaining_keys: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);

useEffect(() => {
  // Try multiple sources to get the role
  let userRole = "";
  
  // 1. Check session_data JSON (most likely where your role is stored)
  try {
    const sessionData = JSON.parse(sessionStorage.getItem("session_data") || "{}");
    userRole = sessionData.role || "";
  } catch (e) {
    console.log("Error parsing session_data:", e);
  }
  
  // 2. If not found, check direct storage keys
  if (!userRole) {
    userRole = sessionStorage.getItem("role") || 
               localStorage.getItem("role") || 
               sessionStorage.getItem("adminRole") || 
               localStorage.getItem("adminRole") || "";
  }
  
  // 3. Handle numeric role values (if stored as 1 or 2)
  if (userRole === "1") userRole = "admin";
  if (userRole === "2") userRole = "superadmin";
  
console.log("✅ Final User Role:", userRole);
setRole(userRole);

// Check whether SuperAdmin has switched to an Admin
// Check whether SuperAdmin has switched to an Admin
const viewAsAdminId =
  sessionStorage.getItem("view_as_admin_id") ||
  localStorage.getItem("view_as_admin_id") ||
  "";

const switchedSuperadminCompany =
  sessionStorage.getItem("is_superadmin_company") ||
  localStorage.getItem("is_superadmin_company") ||
  "";

// Only apply special logic when SuperAdmin is switched
if (userRole === "superadmin" && viewAsAdminId) {
  setIsSwitchedAdmin(true);
  setSwitchedAdminId(String(viewAsAdminId));

  // New feature:
  // Check whether the switched Admin is the SuperAdmin's own company
  const ownCompany = switchedSuperadminCompany === "true";

  setIsOwnSwitchedCompany(ownCompany);

  console.log("🔄 Switched Admin ID:", viewAsAdminId);
  console.log(
    "🏢 Switched Admin is Superadmin Company:",
    ownCompany
  );
} else {
  // Normal SuperAdmin / Admin
  // Existing functionality remains unchanged
  setIsSwitchedAdmin(false);
  setIsOwnSwitchedCompany(false);
  setSwitchedAdminId("");
}
// Allow both admin and superadmin
if (userRole !== "admin" && userRole !== "superadmin") {
  setIsLoading(false);
  setPopupMessage("You are not authorized to generate pilot keys.");
  setPopupType("error");
  setPopupOpen(true);
  return;
}

fetchPilots();
}, []);

const fetchPilots = async () => {
  try {
    setIsLoading(true);

    const response = await fetchTeamRequests({});

    if (response?.pilots) {
      setPilots(response.pilots);

      // Get only companies where BOTH conditions are true
      const adminMap = new Map();

      response.pilots.forEach((pilot) => {
        if (
          pilot.admin_id &&
          pilot.admin_name &&
          pilot.is_superadmin_company === true &&
          pilot.is_dgca_company === true
        ) {
          adminMap.set(pilot.admin_id, {
            admin_id: pilot.admin_id,
            admin_name: pilot.admin_name,
          });
        }
      });

      setEligibleAdmins(Array.from(adminMap.values()));
    } else {
      setPilots([]);
      setEligibleAdmins([]);
    }
  } catch (err) {
    console.error("Error fetching pilots:", err);
    setPilots([]);
    setEligibleAdmins([]);
  } finally {
    setIsLoading(false);
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.trimStart()
    }));
  };

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

  const handleGenerateKey = async (e) => {
    e.preventDefault();
    if (isLoading) return;

      if (role !== "admin" && role !== "superadmin") {
    setPopupMessage("You are not authorized to generate pilot keys.");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (
  role === "superadmin" &&
  isSwitchedAdmin &&
  !isOwnSwitchedCompany
) {
  setPopupMessage(
    "Pilot key generation is not available for this company."
  );
  setPopupType("error");
  setPopupOpen(true);
  return;
}

    if (!formData.email.trim()) {
      setPopupMessage("Email is required");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    if (!validateEmail(formData.email.trim())) {
      setPopupMessage("Please enter a valid email address");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    const normalizedEmail = formData.email.trim().toLowerCase();

    const existingPilot = pilots.find(
      (pilot) =>
        pilot.email &&
        pilot.email.trim().toLowerCase() === normalizedEmail
    );

    if (existingPilot) {
      setPopupMessage("A pilot already exists with this email.");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

   if (
  role === "superadmin" &&
  !isSwitchedAdmin &&
  !formData.admin_id.trim()
) {
  setPopupMessage(
    "Admin ID is required to generate a pilot key for your company."
  );
  setPopupType("error");
  setPopupOpen(true);
  return;
}

    try {
    setIsGeneratingKey(true);

      const payload = {
  email: formData.email.trim().toLowerCase()
};

// Only when SuperAdmin is switched to own company,
// automatically use the switched admin ID.
if (
  role === "superadmin" &&
  isSwitchedAdmin &&
  isOwnSwitchedCompany
) {
  payload.admin_id = switchedAdminId;
}

// Normal SuperAdmin functionality remains unchanged
else if (role === "superadmin" && formData.admin_id) {
  payload.admin_id = formData.admin_id.trim();
}
      const response = await generatePilotKey(payload);

      if (response?.error) {
        if (response.error.includes("Unauthorized") || response.error.includes("Unauthorized Login")) {
          setPopupMessage("Session expired, redirecting to login page");
          setPopupType("error");
          setPopupOpen(true);

          setTimeout(() => {
            navigate("/login");
          }, 2000);
          return;
        }

        setPopupMessage(response.error);
        setPopupType("error");
        setPopupOpen(true);
        return;
      }

      if (response.message) {
        setPopupMessage(response.message);
        setPopupType("success");
        setPopupOpen(true);

        setStats({
          generated_keys: response.generated_keys ?? 0,
          key_limit: response.key_limit ?? 0,
          remaining_keys: response.remaining_keys ?? 0
        });

        setFormData({ email: "", admin_id: "" });
        setShowKeyModal(false);
        fetchPilots();
      }

    } catch (err) {
      if (err?.response?.status === 401 || err?.response?.data?.error?.includes("Unauthorized")) {
        setPopupMessage("Session expired, redirecting to login page");
        setPopupType("error");
        setPopupOpen(true);

        setTimeout(() => {
          navigate("/login");
        }, 2000);
        return;
      }

      const errorMsg = err?.response?.data?.error || "Failed to generate pilot key. Please try again.";
      setPopupMessage(errorMsg);
      setPopupType("error");
      setPopupOpen(true);
      console.error("Error generating pilot key:", err);
    } finally {
    setIsGeneratingKey(false);
}
  };

  const openKeyModal = () => {
    setShowKeyModal(true);
  };

  const closeKeyModal = () => {
    setShowKeyModal(false);
    setFormData({ email: "", admin_id: "" });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch {
      return dateStr;
    }
  };

  // Filter pilots based on search
  const filteredPilots = pilots.filter(pilot => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (pilot.name && pilot.name.toLowerCase().includes(searchLower)) ||
      (pilot.email && pilot.email.toLowerCase().includes(searchLower)) ||
      (pilot.company_name && pilot.company_name.toLowerCase().includes(searchLower)) ||
      (pilot.admin_name && pilot.admin_name.toLowerCase().includes(searchLower))
    );
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPilots = filteredPilots.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPilots.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <Sidebar />

      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Pilot Key Generator</h1>
            <p className="dashboard-subtitle">
              {role === "superadmin"
                ? "Manage pilot registrations for your company"
                : "Manage pilot registrations for your company"}
            </p>
          </div>
          {!(
  role === "superadmin" &&
  isSwitchedAdmin &&
  !isOwnSwitchedCompany
) && (
  <button 
    className="pkg-generate-btn"
    onClick={openKeyModal}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
    </svg>
    Generate Pilot Key
  </button>
)}
        </div>

        {/* Stats Cards */}
        {stats.key_limit > 0 && (
          <div className="pkg-stats-grid">
            <div className="pkg-stat-card pkg-stat-card-generated">
              <div className="pkg-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                </svg>
              </div>
              <div className="pkg-stat-info">
                <span className="pkg-stat-label">Generated Keys</span>
                <span className="pkg-stat-value">{stats.generated_keys}</span>
              </div>
            </div>
            <div className="pkg-stat-card pkg-stat-card-limit">
              <div className="pkg-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="currentColor"/>
                </svg>
              </div>
              <div className="pkg-stat-info">
                <span className="pkg-stat-label">Key Limit</span>
                <span className="pkg-stat-value">{stats.key_limit}</span>
              </div>
            </div>
            <div className="pkg-stat-card pkg-stat-card-remaining">
              <div className="pkg-stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="currentColor"/>
                </svg>
              </div>
              <div className="pkg-stat-info">
                <span className="pkg-stat-label">Remaining Keys</span>
                <span className="pkg-stat-value">{stats.remaining_keys}</span>
              </div>
            </div>
          </div>
        )}

        {/* Search Bar */}
        <div className="pkg-search-container">
          <div className="pkg-search-wrapper">
            <svg className="pkg-search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
            </svg>
            <input
              type="text"
              placeholder="Search pilots by name, email, or company..."
              className="pkg-search-input"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
            {searchTerm && (
              <button className="pkg-clear-search" onClick={() => { setSearchTerm(""); setCurrentPage(1); }}>
                ✕
              </button>
            )}
          </div>
          {/* <div className="pkg-pilot-count">
            <span>{filteredPilots.length} pilot{filteredPilots.length !== 1 ? 's' : ''}</span>
          </div> */}
        </div>

        {/* Table */}
        {isLoading ? (
    <div className="va-loading-container">
        <img
            src={pavamanLogo}
            alt="Loading"
            className="va-spinning-logo"
        />
        <p className="va-loading-text">
            Loading pilots...
        </p>
    </div>
) : (
        <div className="tr-table-container">
          <table className="tr-table">
            <thead className="tr-head">
              <tr>
                <th>Pilot</th>
                <th>Email</th>
                <th>Company</th>
                {/* <th>Admin</th> */}
                <th>Registered On</th>
                <th>Status</th>
                <th>Key</th>
              </tr>
            </thead>
            <tbody>
              {currentPilots.length === 0 ? (
                <tr>
                  <td colSpan="7" className="pkg-empty-table">
                    <div className="pkg-empty-state">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                      </svg>
                      <p>No pilots found</p>
                      <span>Click "Generate Pilot Key" to add a new pilot</span>
                    </div>
                  </td>
                </tr>
              ) : (
                currentPilots.map((pilot) => (
                  <tr key={pilot.id}>
                    <td>
                      <div className="pkg-pilot-cell">
                        <div className="pkg-pilot-avatar-sm">
                          {pilot.name ? pilot.name.charAt(0).toUpperCase() : "P"}
                        </div>
                        <span className="pkg-pilot-name">{pilot.name || "Unknown"}</span>
                      </div>
                    </td>
                    <td className="pkg-email-cell">{pilot.email || "N/A"}</td>
                    <td>{pilot.company_name || "N/A"}</td>
                    {/* <td>{pilot.admin_name || "N/A"}</td> */}
                    <td>{formatDate(pilot.created_on)}</td>
                    <td>
                      <span className={`pkg-status-badge ${pilot.status === 1 ? "pkg-status-active" : "pkg-status-inactive"}`}>
                        {pilot.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      {pilot.signup_key ? (
                        <code className="pkg-key-code-sm">{pilot.signup_key.substring(0, 8)}...</code>
                      ) : (
                        <span className="pkg-no-key">—</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        )}

        {/* Pagination */}
      {!isLoading && totalPages > 1 && (
                    <div className="pv-pilot-pagination-wrapper">
                      <div className="pv-pilot-pagination-controls">
                        <button
                          className="pv-pilot-pagination-btn"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1 || isPaginationLoading}
                        >
                          <FiChevronLeft size={16} />
                          Previous
                        </button>
                        
                        <div className="pv-pilot-page-numbers">
                          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            let pageNumber;
                            if (totalPages <= 5) {
                              pageNumber = i + 1;
                            } else if (currentPage <= 3) {
                              pageNumber = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                              pageNumber = totalPages - 4 + i;
                            } else {
                              pageNumber = currentPage - 2 + i;
                            }
                            
                            return (
                              <button
                                key={pageNumber}
                                className={`pv-pilot-page-btn ${currentPage === pageNumber ? 'pv-pilot-active' : ''}`}
                                onClick={() => handlePageChange(pageNumber)}
                                disabled={isPaginationLoading}
                              >
                                {pageNumber}
                              </button>
                            );
                          })}
                        </div>
                        
                        <button
                          className="pv-pilot-pagination-btn"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages || isPaginationLoading}
                        >
                          Next
                          <FiChevronRight size={16} />
                        </button>
                      </div>
                    </div>
                  )}
      </div>

      {/* Generate Key Modal */}
      {showKeyModal && (
        <div className="pkg-modal-overlay" onClick={closeKeyModal}>
          <div className="pkg-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pkg-modal-header">
              <div className="pkg-modal-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="pkg-modal-title">Generate New Pilot Key</h2>
              <button className="pkg-modal-close" onClick={closeKeyModal}>
                ✕
              </button>
            </div>

            <div className="pkg-modal-body">
              <p className="pkg-modal-description">
                Enter the pilot's email address to generate a unique registration key.
                The key will be sent via email for pilot registration.
              </p>

              <form onSubmit={handleGenerateKey} className="pkg-modal-form">
                <div className="pkg-form-group">
                  <label htmlFor="modal-email" className="pkg-label">
                    Email Address <span className="pkg-required">*</span>
                  </label>
                  <div className="pkg-input-wrapper">
                    <svg className="pkg-input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                    </svg>
                    <input
                      type="email"
                      id="modal-email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="pilot@example.com"
                      className="pkg-modal-input"
                      disabled={isGeneratingKey}
                      autoFocus
                    />
                  </div>
                </div>

             {role === "superadmin" && !isSwitchedAdmin && (
  <div className="pkg-form-group">
    <label htmlFor="modal-admin-id" className="pkg-label">
      Company <span className="pkg-required">*</span>
    </label>

    <div className="pkg-input-wrapper">
      <svg
        className="pkg-input-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-5h6v5M9 8h.01M12 8h.01M15 8h.01M9 11h.01M12 11h.01M15 11h.01"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <select
        id="modal-admin-id"
        name="admin_id"
        value={formData.admin_id}
        onChange={handleInputChange}
        className="pkg-modal-input pkg-modal-select"
        disabled={isGeneratingKey}
      >
        <option value="">Select company</option>

        {eligibleAdmins.map((admin) => (
          <option
            key={admin.admin_id}
            value={admin.admin_id}
          >
            {admin.admin_name}
          </option>
        ))}
      </select>
    </div>

    {eligibleAdmins.length === 0 && (
      <small className="pkg-no-company-message">
        No eligible DGCA companies available.
      </small>
    )}
  </div>
)}

                <div className="pkg-modal-actions">
                  <button type="button" className="pkg-modal-cancel" onClick={closeKeyModal}>
                    Cancel
                  </button>
                 <button
    type="submit"
    className="pkg-modal-submit"
    disabled={
        isGeneratingKey ||
        (stats.key_limit > 0 && stats.remaining_keys === 0)
    }
>
    {isGeneratingKey ? (
        <>
            <svg
                className="pkg-spinner"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
            >
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeDasharray="31.4 31.4"
                    fill="none"
                />
            </svg>
            Generating...
        </>
    ) : stats.key_limit > 0 &&
      stats.remaining_keys === 0 ? (
        "Limit Reached"
    ) : (
        <>
            {/* your existing Generate Key icon */}
            Generate Key
        </>
    )}
</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PilotKeyGeneration;